import type {MaterialStorage} from '@domain/material-storage'
import {MaterialType, useCurrentMaterialStorages} from '@domain/material-storage'

import {useUrlParam} from '../../../../modules/routing'

const selector = (materialType: MaterialType) => (data: MaterialStorage[]) =>
  data.filter((storage) => storage.materialType === materialType)

export const useMaterialStorageListQuery = (materialType?: MaterialType) => {
  const plantCode = useUrlParam('plantCode')
  return useCurrentMaterialStorages({
    plantId: plantCode,
    options: {
      select: materialType ? selector(materialType) : undefined
    }
  })
}
